import { useQuery } from '@tanstack/react-query';
import { fetchAdminIssueTransitions, type AdminIssueTransition } from '../api/adminIssuesApi';

export const adminIssueTransitionsQueryKey = (issueKey: string) => ['adminIssueTransitions', issueKey];

// Available Jira transitions for an issue. Used by the validate dialog and by the
// admin detail header (empty list or a 403 = nothing to show). A 403 means "not a
// gate / not a group member" and won't heal, so retrying is pointless.
export const useAdminIssueTransitions = (issueKey: string | null, enabled: boolean) =>
  useQuery<AdminIssueTransition[]>({
    queryKey: adminIssueTransitionsQueryKey(issueKey ?? ''),
    queryFn: () => fetchAdminIssueTransitions(issueKey as string),
    enabled: enabled && !!issueKey,
    staleTime: 0,
    retry: false,
  });
